import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import looppa from 'looppa';
import { noop } from 'lodash';
import Question from './question';
import Icon from 'components/icon';
import { Link } from 'react-router-dom';
import { Trans } from 'translations';
import classnames from 'classnames';
import normaliseTrailingSlash from 'util/misc/normalise-trailing-slash';

/* eslint-disable camelcase */

export default class Faq extends PureComponent {
    static defaultProps = {
        articles: [],
    };

    static propTypes = {
        title: PropTypes.string.isRequired,
        link: PropTypes.object,
        onEvent: PropTypes.func.isRequired,
        has_anchors: PropTypes.bool.isRequired,
        articles: PropTypes.array.isRequired,
        facet: PropTypes.string,
    };

    static defaultProps = {
        onEvent: noop,
    };

    state = {
        openedQuestionId: null,
    };

    onOpen = (id) => {
        this.props.onEvent('open');
        this.setState({
            openedQuestionId: id,
        });
    };

    onClose = () => {
        this.props.onEvent('close');
    };

    render() {
        const { articles, title, link, has_anchors, facet } = this.props;
        const { openedQuestionId } = this.state;

        return (
            <aside className={classnames('cms-faq', `cms-faq__${ facet }`)}>
                <div className="cms-faq--header">
                    <h2 className="cms-faq--title">{title}</h2>
                    {link ? <Link aria-label={title} className="cms-faq--link u-reset" to={normaliseTrailingSlash(link.to)}><Trans path="faq.link.title"/><Icon symbol="chevron-right"
                        size="small"/></Link> : null}
                </div>
                {looppa(articles)(({ id, ...props }) => (
                    <Question onOpening={() => this.onOpen(id)} has_anchors={has_anchors}
                        onClose={this.onClose}
                        mustBeClosed={openedQuestionId !== id} key={id}
                        id={id} {...props} />
                ))}
            </aside>
        );
    };
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/faq/index.js